<template>
  <div>
    <component :is="type" />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import BankId from '../assets/bankid.svg';
import BankIdNo from '../assets/bankid-no.svg';
import NemId from '../assets/nemid.svg';
import NemIdOrg from '../assets/nemid-organization.svg';
import MitIdDark from '../assets/mitid-dark.svg';
import type { EIdIconType } from '../types/enums/eid-icon-type';

export default defineComponent({
  components: {
    BankId,
    BankIdNo,
    NemId,
    NemIdOrg,
    MitIdDark,
  },
  props: {
    type: {
      type: String as PropType<EIdIconType>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
$icon-size: 1rem;

svg {
  width: $icon-size;
  height: $icon-size;
}
</style>
